import React from 'react';

const TextInput = ({ input, meta, label, ...rest }) => {
  return (
    <div className={"form-control " + (rest.className ? rest.className : "")}>
      {label && (
        <label htmlFor={input.name} className={"label " + (rest.labelClassName ? rest.labelClassName : "")}>
          <span className="label-text">{label}</span>
        </label>
      )}
      <input {...input}
        type="text"
        className={"input w-full " 
          + (meta && meta.error && meta.touched ? "input-error invalid-shadow " : "") 
          + (rest.inputClassName ? rest.inputClassName : "input-bordered")
        }
        placeholder={rest.placeholder}
        disabled={rest.disabled}
        readOnly={rest.readOnly}
      />
      {!rest.noError && (
        <label className="label pb-0">
          <span className="label-text-alt invalid-feedback">{meta && meta.touched && meta.error}</span>
        </label>
      )}

      {meta.data.warning && (
        <label className="label pb-0">
          <span className="label-text-alt text-warning">{meta && meta.touched && meta.data.warning}</span>
        </label>
      )}
    </div>
  )
}

export default TextInput;